import {Component, OnInit} from '@angular/core';
import {FormBuilder, Validators, FormGroup, FormControl} from "@angular/forms";
import {AccountBookingService} from "../../../services/account-booking.service";
import {AuthenticationService, AlertService, LoaderService, SettingsService} from "../../../services/index";
import {ActivatedRoute, Params, Router} from "@angular/router";
declare var $:any;
import * as moment from 'moment';
import {LocationList} from '../../../models/location';
import {AccountsService} from "../../../services/accounts.service";
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

@Component({
  selector: 'app-account-booking',
  templateUrl: './account-booking.component.html',
  styleUrls: ['./account-booking.component.css']
})
export class AccountBookingComponent implements OnInit {
  private moneyRegex = '^([0-9]+|[0-9]*(\.[0-9])([0-9])?)$';
  private accountBookForm;
  private consignmentList;
  private accountBookObject;
  private settingsList;
  private selectedSettingsList;
  private loading = false;
  private id;
  private accountList = [];
  private locations;
  private selectedAccount;
  private printId;
  private netAmountChanged = false;
  private firmDetails;
  statesList = [];
  countryList = [];
  cityList = [];

  constructor(private formBuilder:FormBuilder,
              private accountBookService:AccountBookingService,
              private accountsService:AccountsService,
              private authenticationService:AuthenticationService,
              private alertService:AlertService,
              private settingsService:SettingsService,
              private loaderService:LoaderService,
              private router:Router,
              private route:ActivatedRoute) {
  }

  ngOnInit() {
    this.locations = LocationList;
    this.cityList = [].concat.apply([], this.locations.map(l=>l.city));

    this.route.queryParams.forEach((params:Params) => {
      this.id = params['id'];
      this.printId = this.id;
    });
    this.id ? this.loaderService.loading(true) : null;
    this.accountBookForm = this.formBuilder.group({
      account: ['', Validators.required],
      consignment_number: ['', Validators.required],
      consignment_type: ['Document', Validators.required],
      date: [''],
      booking_date: ['', Validators.required],
      center: ['', Validators.required],
      receiver_gstin: [''],
      receiver_mobile_number: ['', Validators.pattern('^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$')],
      receiver_name: ['', Validators.required],
      receiver_address: ['', Validators.required],
      receiver_country: ['', Validators.required],
      receiver_state: ['Gujarat', Validators.required],
      receiver_city: ['', Validators.required],
      receiver_email: [''],
      remark: [''],
      description: [''],
      courier_company: ['', Validators.required],
      weight: ['', [Validators.pattern(this.moneyRegex), Validators.required]],
      weight_charges: ['', [Validators.pattern(this.moneyRegex), Validators.required]],
      length: ['', Validators.pattern(this.moneyRegex)],
      width: ['', Validators.pattern(this.moneyRegex)],
      height: ['', Validators.pattern(this.moneyRegex)],
      valuation: [''],
      valuation_charge: [''],
      insured: [''],
      insurance_charge: ['', Validators.pattern(this.moneyRegex)],
      pod: [''],
      pod_charge: ['', Validators.pattern(this.moneyRegex)],
      igst_rate: [''],
      igst_amount: ['', Validators.pattern(this.moneyRegex)],
      cgst_rate: [''],
      cgst_amount: ['', Validators.pattern(this.moneyRegex)],
      sgst_rate: [''],
      sgst_amount: ['', Validators.pattern(this.moneyRegex)],
      net_amount: ['', Validators.pattern(this.moneyRegex)],
      pending_amount: [''],
      total_charge: ['', Validators.pattern(this.moneyRegex)]
    });
    $('#date').datetimepicker({
      format: 'DD/MM/YYYY'
    });
    $('#date').on('dp.change', (ev) => {
      this.accountBookForm.patchValue({booking_date: new Date(ev.date.toDate()).getTime()});
    });
    $('#date').on('blur', (ev) => {
      !(<HTMLInputElement>ev.currentTarget).value ? this.accountBookForm.patchValue({booking_date: null}) : null;
    });

    !this.id ? this.getSettingsData() : null;
    !this.id ? this.getNewConsignmentId() : null;
    this.getConsignmentData();
    this.getFirmData();
    this.getAccountList();
    this.id ? this.accountBookService.getById(this.id).subscribe(
      data => {
        this.accountBookObject = data[0] || {};
        $('#date').data("DateTimePicker").date(moment(new Date(data[0].booking_date)).format('DD/MM/YYYY'));
        var patchData = data[0];
        patchData.account = patchData.account._id;
        this.accountBookForm.patchValue(patchData);
        this.getSettingsData();

        setTimeout(()=> {
            data[0].receiver_city ? this.accountBookForm.patchValue({receiver_city: data[0].receiver_city}) : null;
            this.loaderService.loading(false);
          }
          , 800);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.loaderService.loading(false);
      }) : this.accountBookObject = {};

    this.accountBookForm.controls['net_amount'].valueChanges.subscribe(value => {
      this.accountBookForm.patchValue({pending_amount: value});
      this.netAmountChanged ? this._netAmountChanged(value) : null;
    });
    this.accountBookForm.controls['account'].valueChanges.subscribe(value => {
      this.selectedAccount = this.accountList.find(a=>a._id == value);
      this.weightChanged();
    });
    this.accountBookForm.controls['receiver_country'].valueChanges.subscribe(value => {
      this.weightChanged();
    });
    this.accountBookForm.controls['receiver_state'].valueChanges.subscribe(value => {
      this.weightChanged();
    });
    this.accountBookForm.controls['receiver_city'].valueChanges.subscribe(value => {
      var locationDetails = this.locations.find(location=>location.city.indexOf(value) > -1) || {
          country: '',
          state: ''
        };
      locationDetails ? this.accountBookForm.patchValue({
        receiver_country: locationDetails.country,
        receiver_state: locationDetails.state
      }) : null;
      this.weightChanged();
    });
    this.accountBookForm.controls['weight'].valueChanges.subscribe(value => {
      this.weightChanged();
    });
    this.accountBookForm.controls['length'].valueChanges.subscribe(value => {
      this.volumeUnitChanged();
    });
    this.accountBookForm.controls['width'].valueChanges.subscribe(value => {
      this.volumeUnitChanged();
    });
    this.accountBookForm.controls['height'].valueChanges.subscribe(value => {
      this.volumeUnitChanged();
    });
    this.accountBookForm.controls['igst_rate'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.accountBookForm.controls['sgst_rate'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.accountBookForm.controls['cgst_rate'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.accountBookForm.controls['weight_charges'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.accountBookForm.controls['pod_charge'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.accountBookForm.controls['valuation_charge'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.accountBookForm.controls['insurance_charge'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    this.accountBookForm.controls['account'].valueChanges.subscribe(value => {
      !this.netAmountChanged ? this.chargesChanged() : null;
    });
    !this.id ? this.accountBookForm.patchValue({receiver_country: 'India'}) : null;
    !this.id ? this.accountBookForm.patchValue({receiver_state: 'Gujarat'}) : null;
  }

  getFirmData() {
    this.loading = true;
    this.settingsService.firmDetails().subscribe(
      data => {
        data.length ? this.firmDetails = data[0] : null;
        this.loading = false;
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.loaderService.loading(false);
      });
  }

  printBooking($event) {
    $('#printWarningModal').modal('hide');
    this.router.navigate(['/cash_booking_print'], {queryParams: {id: this.printId, type: 'accountBooking'}});
  }

  formatter = (result:string) => `${result} (${this.locations.find(location=>location.city.indexOf(result) > -1).state})`;

  searchCountry = (text$:Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 1 ? []
        : this.countryList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

  searchState = (text$:Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 1 ? []
        : this.statesList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

  searchCity = (text$:Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term =>term.length < 3 ? [] : this.cityList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1));

  getAccountList() {
    this.accountsService
      .list()
      .subscribe(
        data => {
          this.accountList = data;
        },
        error => {
          this.alertService.error(error);
          this.loaderService.loading(false);
        });
  }

  getNewConsignmentId() {
    this.loaderService.loading(true);
    this.settingsService
      .consignmentNumber()
      .subscribe(
        data => {
          this.accountBookForm.patchValue(data);
          this.loaderService.loading(false);
        },
        error => {
          this.alertService.error(error);
          this.loaderService.loading(false);
        });
  }

  getConsignmentData() {
    this.settingsService.consignmentList().subscribe(
      data => {
        this.consignmentList = data || [];
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loaderService.loading(false);
      });
  }

  getSettingsData() {
    this.settingsService.getSettings().subscribe(
      data => {
        this.settingsList = data || [];
        !this.id ? this.onConsignmentTypeChange() : this.selectedSettingsList = this.settingsList.find(s=>s.consignment_type == this.accountBookForm.controls['consignment_type'].value);
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
        this.loaderService.loading(false);
      });
  }

  onConsignmentTypeChange() {
    this.selectedSettingsList = this.settingsList.find(s=>s.consignment_type == this.accountBookForm.controls['consignment_type'].value);
    var data = this.selectedSettingsList ? {
      igst_rate: this.selectedSettingsList.igst_rate,
      cgst_rate: this.selectedSettingsList.cgst_rate,
      sgst_rate: this.selectedSettingsList.sgst_rate
    } : {
      igst_rate: '',
      cgst_rate: '',
      sgst_rate: ''
    };
    data ? this.accountBookForm.patchValue(data) : null;
    this.weightChanged();
    this.volumeUnitChanged();
  }

  volumeUnitChanged() {
    var weight = ((this.accountBookForm.controls.length.value && this.accountBookForm.controls.length.valid ? parseFloat(this.accountBookForm.controls.length.value) : 0)
      * (this.accountBookForm.controls.width.value && this.accountBookForm.controls.width.valid ? parseFloat(this.accountBookForm.controls.width.value) : 0)
      * (this.accountBookForm.controls.height.value && this.accountBookForm.controls.height.valid ? parseFloat(this.accountBookForm.controls.height.value) : 0)) / 5;
    this.selectedSettingsList ? this.accountBookForm.patchValue({weight: weight || 0}) : null;
  }

  weightChanged() {
    this.selectedSettingsList && this.selectedAccount ? this.accountBookForm.patchValue({weight_charges: this.getAppropriateWeightRangeRateFromArray(parseFloat(this.accountBookForm.controls.weight.value) || 0)}) : 0;
  }

  getAppropriateWeightRangeRateFromArray(weight:number) {
    var charge:number = 0;
    var thousandPlus:number = 0;
    weight > 1000 ? ((thousandPlus = (parseInt((weight / 1000).toFixed(0)) - (weight % 1000 == 0 ? 1 : 0))), weight = 1000) : null;
    if (this.firmDetails && this.accountBookForm.controls.receiver_country.value && this.accountBookForm.controls.receiver_state.value && this.accountBookForm.controls.receiver_city.value) {
      var rate_type = this.accountBookForm.controls.receiver_country.value.toLowerCase() != 'india' ?
        "weight_range_rate_roi"
        : this.accountBookForm.controls.receiver_state.value.toLowerCase() == this.firmDetails.state.toLowerCase() ?
        this.accountBookForm.controls.receiver_city.value.toLowerCase() == this.firmDetails.city.toLowerCase() ?
          "weight_range_rate" : "weight_range_rate_cross"
        : this.accountBookForm.controls.receiver_city.value.toLowerCase() == "mumbai" ?
        "weight_range_rate_mumbai" : "weight_range_rate_roi";

      var amount = parseFloat(this.selectedAccount[rate_type].find(rate=>rate.start <= weight && rate.end >= weight).amount);
      charge = amount > 0 ? amount : parseFloat(this.selectedSettingsList[rate_type].find(rate=>rate.start <= weight && rate.end >= weight).amount);
      var selectedAccountThousandPlusAmount = parseFloat(this.selectedAccount[rate_type].find(rate=>rate.end == '+').amount);
      thousandPlus ? charge += (selectedAccountThousandPlusAmount ? selectedAccountThousandPlusAmount : parseFloat(this.selectedSettingsList[rate_type].find(rate=>rate.end == '+').amount)) * thousandPlus : null;
    }
    return charge;
  }


  _netAmountChanged(netAmount) {
    var total = 0;
    netAmount = parseInt(netAmount);
    if (netAmount && this.accountBookForm.controls.receiver_state.value && this.selectedAccount && this.accountBookForm.controls.receiver_country.value && this.firmDetails) {

      total = this.accountBookForm.controls.receiver_country.value.toLowerCase() != 'india' ? netAmount :
        this.accountBookForm.controls.receiver_state.value.toLowerCase() != this.firmDetails.state.toLowerCase() ?
          ((netAmount * 100) / (parseFloat(this.accountBookForm.controls.igst_rate.value) + 100))
          : ((netAmount * 100) / ((parseFloat(this.accountBookForm.controls.cgst_rate.value) + parseFloat(this.accountBookForm.controls.sgst_rate.value)) + 100));

      total = parseFloat(total.toFixed(2));
      this.accountBookForm.patchValue({total_charge: total});

      this.accountBookForm.controls.valuation_charge.value && this.accountBookForm.controls.valuation_charge.valid ? total -= parseFloat(this.accountBookForm.controls.valuation_charge.value) : null;
      this.accountBookForm.controls.pod_charge.value && this.accountBookForm.controls.pod_charge.valid ? total -= parseFloat(this.accountBookForm.controls.pod_charge.value) : null;
      this.accountBookForm.controls.insurance_charge.value && this.accountBookForm.controls.insurance_charge.valid ? total -= parseFloat(this.accountBookForm.controls.insurance_charge.value) : null;
      total = parseFloat(total.toFixed(2));
      this.accountBookForm.patchValue({weight_charges: total});

      this.accountBookForm.controls.receiver_country.value.toLowerCase() != "india" ? (
        this.accountBookForm.patchValue({igst_amount: ''}),
          this.accountBookForm.patchValue({cgst_amount: ''}),
          this.accountBookForm.patchValue({sgst_amount: ''})) :
        this.accountBookForm.controls.receiver_state.value.toLowerCase() != this.firmDetails.state.toLowerCase() ?
          (this.accountBookForm.controls.igst_rate.value && this.accountBookForm.controls.igst_rate.valid ? this.accountBookForm.patchValue({igst_amount: parseFloat(((total * this.accountBookForm.controls.igst_rate.value) / 100).toFixed(2))}) : this.accountBookForm.patchValue({igst_amount: ''}),
            this.accountBookForm.patchValue({cgst_amount: ''}),
            this.accountBookForm.patchValue({sgst_amount: ''}))
          : (this.accountBookForm.patchValue({igst_amount: ''}), this.accountBookForm.controls.cgst_rate.value && this.accountBookForm.controls.cgst_rate.valid ? this.accountBookForm.patchValue({cgst_amount: parseFloat(((total * this.accountBookForm.controls.cgst_rate.value) / 100).toFixed(2))}) : this.accountBookForm.patchValue({cgst_amount: ''}),
          this.accountBookForm.controls.sgst_rate.value && this.accountBookForm.controls.sgst_rate.valid ? this.accountBookForm.patchValue({sgst_amount: parseFloat(((total * this.accountBookForm.controls.sgst_rate.value) / 100).toFixed(2))}) : this.accountBookForm.patchValue({sgst_amount: ''}));
    }
  }

  netAmountFocused() {
    this.netAmountChanged = true;
  }

  netAmountBlured() {
    this.netAmountChanged = false;
  }

  chargesChanged():void {
    var total = 0;
    if (this.accountBookForm.controls.receiver_country.value && this.accountBookForm.controls.receiver_state.value && this.selectedAccount && this.firmDetails) {
      this.accountBookForm.controls.weight_charges.value && this.accountBookForm.controls.weight_charges.valid ? total += parseFloat(this.accountBookForm.controls.weight_charges.value) : null;
      this.accountBookForm.controls.valuation_charge.value && this.accountBookForm.controls.valuation_charge.valid ? total += parseFloat(this.accountBookForm.controls.valuation_charge.value) : null;
      this.accountBookForm.controls.pod_charge.value && this.accountBookForm.controls.pod_charge.valid ? total += parseFloat(this.accountBookForm.controls.pod_charge.value) : null;
      this.accountBookForm.controls.insurance_charge.value && this.accountBookForm.controls.insurance_charge.valid ? total += parseFloat(this.accountBookForm.controls.insurance_charge.value) : null;
      total = parseFloat(total.toFixed(2));
      this.accountBookForm.patchValue({total_charge: total});
      this.accountBookForm.controls.receiver_country.value.toLowerCase() != 'india' ? (
        this.accountBookForm.patchValue({igst_amount: ''}),
          this.accountBookForm.patchValue({cgst_amount: ''}),
          this.accountBookForm.patchValue({sgst_amount: ''})) :
        this.accountBookForm.controls.receiver_state.value.toLowerCase() != this.firmDetails.state.toLowerCase() ?
          (this.accountBookForm.controls.igst_rate.value && this.accountBookForm.controls.igst_rate.valid ? this.accountBookForm.patchValue({igst_amount: parseFloat(((total * this.accountBookForm.controls.igst_rate.value) / 100).toFixed(2))}) : this.accountBookForm.patchValue({igst_amount: ''}),
            this.accountBookForm.patchValue({cgst_amount: ''}),
            this.accountBookForm.patchValue({sgst_amount: ''}))
          : (this.accountBookForm.patchValue({igst_amount: ''}), this.accountBookForm.controls.cgst_rate.value && this.accountBookForm.controls.cgst_rate.valid ? this.accountBookForm.patchValue({cgst_amount: parseFloat(((total * this.accountBookForm.controls.cgst_rate.value) / 100).toFixed(2))}) : this.accountBookForm.patchValue({cgst_amount: ''}),
          this.accountBookForm.controls.sgst_rate.value && this.accountBookForm.controls.sgst_rate.valid ? this.accountBookForm.patchValue({sgst_amount: parseFloat(((total * this.accountBookForm.controls.sgst_rate.value) / 100).toFixed(2))}) : this.accountBookForm.patchValue({sgst_amount: ''}));
      this.accountBookForm.patchValue({net_amount: parseFloat((total + (this.accountBookForm.controls.receiver_state.value.toLowerCase() != this.firmDetails.state.toLowerCase() ? (this.accountBookForm.controls.igst_amount.value || 0) : ((this.accountBookForm.controls.cgst_amount.value || 0) + (this.accountBookForm.controls.sgst_amount.value || 0)))).toFixed(2))});
    }
    else {
      this.accountBookForm.patchValue({cgst_amount: ''});
      this.accountBookForm.patchValue({sgst_amount: ''});
      this.accountBookForm.patchValue({igst_amount: ''});
      this.accountBookForm.patchValue({total_charge: 0});
      this.accountBookForm.patchValue({net_amount: 0});
    }
  }

  setDate():void {
    // Set today date using the patchValue function
    let date = new Date();
    this.accountBookForm.patchValue({
      myDate: {
        date: {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
        }
      }
    });
  }

  validateAllFormFields(formGroup:FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
    $(document).ready(function () {
      $('html, body').animate({
        scrollTop: $('.alert-danger').closest('.form-group').offset().top - 56
      }, 500);
    });
  }

  submitAccountBooking() {
    // Object.keys(this.accountBookForm.controls).forEach((k)=> {
    //   console.log(k, ' = ', this.accountBookForm.controls[k].value, ' - ', this.accountBookForm.controls[k].valid);
    // });
    this.accountBookForm.valid ? this.createNewCashBooking() : this.validateAllFormFields(this.accountBookForm);
  }

  createNewCashBooking() {
    this.loading = true;
    var value = this.accountBookForm.value;
    !this.accountBookObject._id ? value['created_by'] = this.authenticationService.user()._id : null;
    this.accountBookObject._id ?
      this.accountBookService.putById(this.accountBookObject._id, value)
        .subscribe(
          data => {
            this.alertService.success('Account Booking Updated...', true);
            this.accountBookForm.reset();
            this.accountBookObject = {};
            this.router.navigate(['/account_booking_list']);
          },
          error => {
            this.alertService.error(error);
            this.loading = false;
          })
      : this.accountBookService.create(value)
      .subscribe(
        data => {
          this.alertService.success('Account Booking Generated...', true);
          this.accountBookForm.reset();
          this.loading = false;
          this.accountBookForm.patchValue({receiver_country: 'India'});
          this.accountBookForm.patchValue({receiver_state: 'Gujarat'});
          this.getNewConsignmentId();
          this.printId = data._id;
          $('#printWarningModal').modal('show');
        },
        error => {
          var message = error._body ? JSON.parse(error._body).message : null;
          this.alertService.error(message || error);
          this.loading = false;
        });
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/account-booking/account-booking/account-booking.component.ts